import { all, put, race, select, take } from 'redux-saga/effects';

import * as CarInstanceActions from 'store/carInstance/actions';
import * as CarInstanceConstants from 'store/carInstance/constants';
import * as CarInstanceSelectors from 'store/carInstance/selectors';
import * as CarReferenceActions from 'store/carReference';
import * as CarReferenceConstants from 'store/carReference/constants';
import * as CarReferenceSelectors from 'store/carReference/selectors';
import { selectWhen } from 'store/helpers';
import * as UserSelectors from 'store/user/selectors';

import * as InsuranceConstants from '../../constants';
import { CreateStage } from '../../helpers';

function* checkVersionsRequest() {
  const [, error] = yield race([
    take(CarReferenceConstants.CAR_REFERENCE_LOADED_VERSIONS),
    selectWhen(CarReferenceSelectors.selectError, Boolean),
  ]);

  if (error) {
    CreateStage.throwError({ message: error });
  }
}

export const insuranceStageSelectModel = new CreateStage({
  action: InsuranceConstants.ACTIONS.SELECT_MODEL,
  handler: function* () {
    const [dealerId] = yield all([
      selectWhen(UserSelectors.getDealerId),
      // Ждем когда car instance заполнится
      selectWhen(CarInstanceSelectors.selectFetch, false),
      // Ждем когда загрузится список моделей
      selectWhen(CarReferenceSelectors.selectModelsFetch, false),
    ]);

    const {
      [CarInstanceConstants.VALUE_FIELDS.IS_NEW]: isNew,
      [CarInstanceConstants.VALUE_FIELDS.MODEL]: model,
    } = yield selectWhen(CarInstanceSelectors.selectValues);
    const models = yield select(CarReferenceSelectors.selectModels);

    // Если не выбрана модель или нет списка с моделями, то нет смысла продолжать флоу
    if (!model || !Array.isArray(models)) {
      return;
    }

    const foundModel = models.find((target) => {
      const { value } = target ?? {};

      return value === model;
    });
    const { id: modelId } = foundModel ?? {};

    // Выбираем модель, устраивает и undefined
    yield put(
      CarReferenceActions.setSelected({
        [CarReferenceConstants.SELECTED_FIELDS.MODEL]: foundModel,
      })
    );

    if (typeof modelId !== 'undefined') {
      const { id: brandId } = (yield select(CarReferenceSelectors.selectSelectedBrand)) ?? {};

      if (!isNew || !brandId) {
        return;
      }

      // Подгружаем список комплектаций
      yield put(
        CarReferenceActions.loadVersions({
          brandId,
          dealerId,
          modelId,
        })
      );
      // Ждем когда загрузится список комплектаций
      yield* checkVersionsRequest();

      return;
    }

    // Сбрасываем состояния если неизвестная модель
    yield put(
      CarInstanceActions.setCarInstance({
        [CarInstanceConstants.VALUE_FIELDS.MODEL]: undefined,
        [CarInstanceConstants.VALUE_FIELDS.YEAR]: undefined,
      })
    );
  },
  name: InsuranceConstants.STAGES_FIELDS.SELECT_MODEL,
}).watcher;
